import { NgModule } from '@angular/core';
import { WsArticuloService } from './ws-articulo.service';
import { HttpClientModule } from '@angular/common/http';
import { WsContactoService } from './ws-contacto.service';
import { WsDevolucionService } from './ws-devolucion-ov.service';
import { WsGlobalService } from './ws-global.service';
import { WsUbigeoService } from './ws-ubigeo.service';
import { WsOrdenService } from './ws-orden.service';
import { WsProductoService } from './ws-producto.service';
import { WsProductoCartService } from './ws-producto-cart.service';
import { WsFileService } from './ws-file.service';
import { WsSolicitudesService } from './ws-solicitudes.service';
import { WsSucursalRecojoService } from './ws-sucursal-recojo.service';
import { WsTicketService } from './ws-ticket.service';
import { WsTicketWebService } from './ws-ticketweb.service';
import { WsComentarioService } from './ws-comentario.service';
import { WsClienteService } from './ws-cliente.service';
import { WsAuthService } from './ws-auth.service';
import { WsEncuestaService } from './ws-encuesta.service';
import { TarifaService } from './tarifa.service';

@NgModule({
	imports: [
		HttpClientModule
	],
	providers: [
		WsFileService,
		WsArticuloService,
		WsAuthService,
		WsContactoService,
		WsDevolucionService,
		WsGlobalService,
		WsUbigeoService,
		WsOrdenService,
		WsProductoService,
		WsProductoCartService,
		WsSolicitudesService,
		WsTicketService,
		WsTicketWebService,
		WsComentarioService,
		WsClienteService,
		WsEncuestaService,
		WsSucursalRecojoService,
		TarifaService
	]
})
export class CiptechHttpModule { }
